var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.334 3.33268C18.334 2.41221 17.5878 1.66602 16.6673 1.66602H15.0007C14.0802 1.66602 13.334 2.41221 13.334 3.33268V16.666C13.334 17.5865 14.0802 18.3327 15.0007 18.3327H16.6673C17.5878 18.3327 18.334 17.5865 18.334 16.666V3.33268ZM15.0007 3.33268L16.6673 3.33268V16.666H15.0007V3.33268Z",
    fill: "#4F5E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5007 7.49935C12.5007 6.57887 11.7545 5.83268 10.834 5.83268H9.16732C8.24684 5.83268 7.50065 6.57887 7.50065 7.49935V16.666C7.50065 17.5865 8.24684 18.3327 9.16732 18.3327H10.834C11.7545 18.3327 12.5007 17.5865 12.5007 16.666V7.49935ZM9.16732 7.49935H10.834V16.666H9.16732V7.49935Z",
    fill: "#4F5E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66732 11.666C6.66732 10.7455 5.92113 9.99935 5.00065 9.99935H3.33398C2.41351 9.99935 1.66732 10.7455 1.66732 11.666V16.666C1.66732 17.5865 2.41351 18.3327 3.33398 18.3327H5.00065C5.92113 18.3327 6.66732 17.5865 6.66732 16.666V11.666ZM3.33398 11.666H5.00065V16.666H3.33398V11.666Z",
    fill: "#4F5E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.87c5773adea28ff40a37436a5c12780f.svg";
export { ForwardRef as ReactComponent };